import * as _ from 'underscore';
import { isNullOrUndefined, isUndefined } from '../../../models/utils';
import { ContextMenuOption } from '../../../models/context-menu-option';
import { DrRequestInfo } from '../../../models/dr-request-info';
import { Endpoint, EntityType, SearchType } from '../../../models/enums';
import { NavigationInfo } from '../../../models/navigation-info';
import { SavedSearch } from '../../../models/saved-searches';
import { SearchResult } from '../../../models/search-result';
import { ViewType } from '../../../models/view';
import { GenericTreeNode } from '../../generic-tree/generic-tree-node';
import { ObjectActionListType, ActionType, PermissionSet } from '../../../models/permission';


export const contextMenuOptionsSearchHistory = [
    new ContextMenuOption({
        name: 'Add Tags ...', iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => (item.data as SearchResult).task !== SearchType.BULK && !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissionsGetter: (item: GenericTreeNode) => (item.data as SearchResult).viewType === ViewType.CORPUS_SET_RESULT || (item.data as SearchResult).viewType === ViewType.CORPUS_RESULT ?
            [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] },
            { permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE], isMandatory: true }] :
            [{ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] }],
    }),
    new ContextMenuOption({
        name: 'Remove Tags ...', iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => (((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK) &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] })],
    }),
    new ContextMenuOption({
        divider: true,
        visible: (item: GenericTreeNode) => (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName' })?.value?.includes('Discard Pile')),
    }),
    new ContextMenuOption({
        name: 'Add to ...', iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName' })?.value?.includes('Discard Pile')),
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    }),
    new ContextMenuOption({
        name: 'Remove from ...', iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => (((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK) &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [{ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] },
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    }),
    new ContextMenuOption({
        name: 'Remove from Project Data', iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName' })?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Save Search ...',
        iconClass: 'fa-save', iconColor: 'color-tan-07',
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            !(item.data as SearchResult).name.toLowerCase().startsWith('drill-through') &&
            !(item.data as SearchResult).name.toLowerCase().startsWith('search by synthetic document') &&
            (item.data as SearchResult).task !== SearchType.COLLECTION_SIMILARITY &&
            (item.data as SearchResult).task !== SearchType.VECTOR_SET_FIND_DUPLICATES &&
            !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            (item.data as SearchResult).task !== SearchType.METADATA_BULK &&
            isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'sampleSetResult' })) &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.SAVED_SEARCH_QUERY, permissionActions: [ActionType.CREATE] })],
    }),
    new ContextMenuOption({
        divider: true,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            !(item.data as SearchResult).name.toLowerCase().startsWith('drill-through') &&
            !(item.data as SearchResult).name.toLowerCase().startsWith('search by synthetic document') &&
            (item.data as SearchResult).task !== SearchType.COLLECTION_SIMILARITY &&
            (item.data as SearchResult).task !== SearchType.VECTOR_SET_FIND_DUPLICATES &&
            !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'sampleSetResult' })) &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile'))
    }),
    new ContextMenuOption({
        name: 'Find Exact Duplicates', iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK
    }),
    new ContextMenuOption({
        name: 'Find Content Duplicates', iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK
    }),
    new ContextMenuOption({
        divider: true,
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK
    }),
    new ContextMenuOption({
        name: 'Calculate Word List',
        iconClass: 'fa-font', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-refresh', iconSecondColor: 'color-blue-01',
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT })))
    }),
    new ContextMenuOption({
        name: 'View Word List ...', iconClass: 'fa-font', iconColor: 'color-blue-01', tooltip: 'Please Calculate Word List to view it',
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT })))
    }),
    new ContextMenuOption({
        divider: true,
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT })))
    }),
    new ContextMenuOption({
        name: 'Create Data Set from Search Results ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison && (item.data as SearchResult).attributes &&
            !isNullOrUndefined((item.data as SearchResult).attributes.find(a => a.name === 'allowDataSetCreation')) &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Create Manifest ...', iconClass: 'fa-list-alt', iconColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => (item.data as SearchResult).task !== SearchType.BULK,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_REPORTS })],
    }),
    new ContextMenuOption({
        name: 'Create Comparison ...',
        iconClass: 'fa-exchange', iconColor: 'color-purple-02',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [{ permissionType: ObjectActionListType.COMPARISONS, permissionActions: [ActionType.CREATE] }]
    }),
    new ContextMenuOption({
        name: 'Create Sample ...',
        iconClass: 'fa-eyedropper', iconColor: 'color-tan-07',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK && 
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile'))
    }),
    new ContextMenuOption({
        name: 'Create Export Comparison Report ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            !(item.data as SearchResult).exportComparison && (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.EXPORT_STREAM })],
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Download All as PDFs', iconClass: 'fa-file-pdf-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        permissions: [{ permissionType: ObjectActionListType.DOWNLOAD_PDF }]
    }),
    new ContextMenuOption({
        name: 'Download All Natives', iconClass: 'fa-file', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        permissions: [{ permissionType: ObjectActionListType.DOWNLOAD_NATIVES }]
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Update Metadata ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.CORPUS_SET_RESULT ||
            (item.data as SearchResult).viewType === ViewType.CORPUS_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.CORPUS_SET_RESULT })) || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.CORPUS_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Reprocess ...',
        iconClass: 'fa-retweet', iconColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0 && (item.data.viewType != null || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype' }))),
        visible: (item: GenericTreeNode) => !(item.data as SearchResult).exportComparison &&
            (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Extract Office 365 Data ...',
        iconClass: 'fa-cloud', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-paperclip', iconSecondColor: 'color-green-04',
        visible: (item: GenericTreeNode) => item.data instanceof SearchResult && (
            (item.data as SearchResult).name.toLowerCase().includes('modern attachment retrieve warning') ||
            (item.data as SearchResult).name.toLowerCase().includes('missing channel name warning')
        ),
        tooltip: 'No available Office 365 Connectors',
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'OCR ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.CORPUS_SET_RESULT ||
            (item.data as SearchResult).viewType === ViewType.CORPUS_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.CORPUS_RESULT })) || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.CORPUS_SET_RESULT }))) && (item.data as SearchResult).attributes &&
            !isNullOrUndefined((item.data as SearchResult).attributes.find(a => a.name === 'ocrView' || a.name === 'ocrCandidateDrillDown')) &&
            (item.data as SearchResult).task !== SearchType.BULK,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Copy to External Area ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.CORPUS_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.CORPUS_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] }),
        new PermissionSet({ permissionType: ObjectActionListType.CONNECTOR_ACCESS })]
    }),
    new ContextMenuOption({
        name: 'Load from External Area ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.CORPUS_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.CORPUS_RESULT }))) &&
            (item.data as SearchResult).task !== SearchType.BULK,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.CORPUS, permissionActions: [ActionType.CREATE] }),
        new PermissionSet({ permissionType: ObjectActionListType.CONNECTOR_ACCESS })]
    }),
    new ContextMenuOption({
        name: 'Copy for External Imaging ...',
        enabled: (item: GenericTreeNode) => (item.data as SearchResult).documentCount > 0,
        visible: (item: GenericTreeNode) => ((item.data as SearchResult).viewType === ViewType.WORKING_SET_RESULT || !isUndefined(_.findWhere((item.data as SearchResult).attributes, { name: 'viewtype', value: ViewType.WORKING_SET_RESULT }))) &&
            !(item.data as SearchResult).exportComparison && (item.data as SearchResult).task !== SearchType.BULK &&
            !(_.findWhere((item.data as SearchResult).attributes, { name: 'targetViewName'})?.value?.includes('Discard Pile')),
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }),
        new PermissionSet({ permissionType: ObjectActionListType.CONNECTOR_ACCESS })]
    })
];

export const contextMenuOptions = [
    new ContextMenuOption({
        name: 'Add Tags ...', iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Remove Tags ...', iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_TAGS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Add to ...', iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] }),
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    }),
    new ContextMenuOption({
        name: 'Remove from ...', iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_FOLDER, permissionActions: [ActionType.CREATE] }),
        { permissionType: ObjectActionListType.DOCUMENT_CUSTODIAN, permissionActions: [ActionType.CREATE] }],
        atLeastOne: true
    }),
    new ContextMenuOption({
        name: 'Remove from Project Data', iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [{ permissionType: ObjectActionListType.ECA_CASE_DATA, permissionActions: [ActionType.CREATE] }]
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Find Exact Duplicates', iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
    }),
    new ContextMenuOption({
        name: 'Find Content Duplicates', iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
    }),
    new ContextMenuOption({
        divider: true,
    }),
    new ContextMenuOption({
        name: 'Calculate Word List',
        iconClass: 'fa-font', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-refresh', iconSecondColor: 'color-blue-01',
    }),
    new ContextMenuOption({
        name: 'View Word List ...', iconClass: 'fa-font', iconColor: 'color-blue-01', tooltip: 'Please Calculate Word List to view it'
    }),
    new ContextMenuOption({
        divider: true,
    }),
    new ContextMenuOption({
        name: 'Create Manifest ...', iconClass: 'fa-list-alt', iconColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.DOCUMENT_REPORTS })]
    }),
    new ContextMenuOption({
        name: 'Create Comparison ...',
        iconClass: 'fa-exchange', iconColor: 'color-purple-02',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [new PermissionSet({ permissionType: ObjectActionListType.COMPARISONS, permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Create Sample ...',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Download All as PDFs', iconClass: 'fa-file-pdf-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [{ permissionType: ObjectActionListType.DOWNLOAD_PDF }]
    }),
    new ContextMenuOption({
        name: 'Download All Natives', iconClass: 'fa-file', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0,
        permissions: [{ permissionType: ObjectActionListType.DOWNLOAD_NATIVES }]
    }),
    new ContextMenuOption({ divider: true }),
    new ContextMenuOption({
        name: 'Update Saved Search',
        enabled: (item: GenericTreeNode) => (item.data as SavedSearch).view && (item.data as SavedSearch).view.documentCount > 0
    }),
    new ContextMenuOption({ divider: true, visible: (item: GenericTreeNode) => (item.data instanceof SavedSearch) }),
    new ContextMenuOption({
        name: 'Edit ...', iconClass: 'fa-pencil', iconColor: 'color-blue-01',
        permissions: [new PermissionSet({ permissionActions: [ActionType.CREATE] })]
    }),
    new ContextMenuOption({
        name: 'Delete', iconClass: 'fa-trash', iconColor: 'color-red-05',
        permissions: [new PermissionSet({ permissionActions: [ActionType.DELETE] })]
    })
];

export const SearchMenu = new GenericTreeNode({
    name: 'Searches',
    entityType: EntityType.searchResult,
    customClasses: 'panel-header',
    automationId: 'nav-tree-searches',
    isExpanded: true,
    isExpandable: true,
    isExpandedOnSelect: true,
    isSelectable: false,
    navigationInfo: new NavigationInfo(
        { name: 'All Docs', path: 'document-list', default: true },
        { name: 'Email Threads', path: 'email-thread' },
        { name: 'Short Message Threads', path: 'short-message-thread' },
        { name: 'Communication Grid', path: 'communication-matrix' },
        { name: 'Domain Grid', path: 'domain-matrix' },
        { name: 'Reports', path: 'reports' },
        { name: 'Clusters', path: 'cluster-list' }
    )
});

export const SearchSavedSearchMenu = new GenericTreeNode({
    name: 'Saved Searches',
    entityType: EntityType.savedSearch,
    automationId: 'nav-tree-searches-saved-searches',
    isExpandable: true,
    isExpandedOnSelect: true,
    navigationInfo: new NavigationInfo({ path: 'summary' }),
    requestInfo: new DrRequestInfo({
        endpoint: Endpoint.projectManager_listSavedSearches,
        responseName: 'activeRules',
        data: {
            selectedAttributes: [],
            startIndex: 0
        }
    }),
    childPadding: 0,
    permissions: [new PermissionSet({ permissionType: ObjectActionListType.SAVED_SEARCH_QUERY })],

    createChild: (data: any, handler?: any): GenericTreeNode => {
        const item = new SavedSearch(data);
        return new GenericTreeNode({
            name: item.name,
            automationId: 'saved-search-' + item.name,
            entityType: EntityType.savedSearch,
            // iconStringContent: item.iconStringContent ? item.iconStringContent : 'F',
            icon: 'fa-search',
            iconColor: ' color-tan-07',
            customNumber: item.view ? item.view.documentCount : 0,
            onContextMenuAction: SearchMenu.onContextMenuAction,
            navigationInfo: SearchMenu.navigationInfo,
            contextMenuOptions: contextMenuOptions,
            permissions: [new PermissionSet({ permissionType: ObjectActionListType.SAVED_SEARCH_QUERY })],
            data: item,
        }, handler);
    }
});

export const searchNodeID = 'nav-tree-searches-search-history';
export const SearchSearchHistoryMenu = new GenericTreeNode({
    name: 'Search History',
    entityType: EntityType.searchResult,
    automationId: searchNodeID,
    isExpandable: true,
    isExpandedOnSelect: true,
    navigationInfo: new NavigationInfo({ path: 'summary' }),
    requestInfo: new DrRequestInfo({
        endpoint: Endpoint.projectManager_listSearchHistory,
        responseName: 'views',
        data: {
            filters: [{ attribute: 'docBasedResultsOnly', value: 'true', operator: 'EQUALS' }],
            selectedAttributes: ['hidebulksearchchildren', 'includebulksearchparents'],
            startIndex: 0,
            count: 10
        }
    }),
    childPadding: 0,
    createChild: (data: any, handler?: any): GenericTreeNode => {
        const item = new SearchResult(data);
        const isBulkSearchParentNode = item.task === 'BULK_SEARCH';
        let temp = '';
        if (item.task === 'VECTOR_SET_SEARCH' || item.task === 'METADATA_BULK_SEARCH' || item.task === 'DOCUMENT_FIND_DUPLICATES' || item.task === SearchType.SEARCH_FROM_BULK_SEARCH ||
            item.task === SearchType.COLLECTION_SIMILARITY || item.task === SearchType.VECTOR_SET_FIND_DUPLICATES) {
            if (!isUndefined(_.findWhere(item.attributes, { name: 'sampleSetResult' }))) {
                temp = 'fa-eyedropper';
            } else {
                temp = 'fa-search';
            }
        } else {
            temp = 'fa-folder';
        }
        const childNode = new GenericTreeNode({
            name: item.name,
            automationId: 'search-result-' + item.handle,
            entityType: EntityType.searchResult,
            domId: `node_${item?.handle}`,
            icon: temp,
            iconColor: 'color-tan-07',
            customNumber: isBulkSearchParentNode ? undefined : item.documentCount,
            contextMenuOptions: contextMenuOptionsSearchHistory,
            onContextMenuAction: SearchMenu.onContextMenuAction,
            navigationInfo: isBulkSearchParentNode ? (new NavigationInfo(
                { name: 'Reports', path: 'reports', default: true },
            )) : ((item.viewType === ViewType.CORPUS_SET_RESULT || item.viewType === ViewType.CORPUS_RESULT) ?
                new NavigationInfo(
                    { name: 'All Docs', path: 'document-list', default: true },
                    { name: 'Communication Grid', path: 'communication-matrix' },
                    { name: 'Domain Grid', path: 'domain-matrix' },
                    { name: 'Reports', path: 'reports' },
                ) : SearchMenu.navigationInfo),
            data: item
        }, handler);
        if (isBulkSearchParentNode) {
            childNode.isExpandable = true;
            childNode.isExpandedOnSelect = true;
            childNode.requestInfo = new DrRequestInfo({
                endpoint: Endpoint.viewManager_listBulkSearchChildViews,
                responseName: 'views',
                data: {
                    handle: item.handle,
                    startIndex: 0,
                    count: 10
                }
            });
            childNode.hasExpanderPadding = false;
            childNode.childPadding = 10;
            childNode.parent = SearchSearchHistoryMenu;
            childNode.filterBy = SearchSearchHistoryMenu.filterBy;
            childNode.createChild = (searchFromBulk: any): GenericTreeNode => {
                const viewItem = new SearchResult(searchFromBulk);
                const hasExportComparisonReports = _.findWhere(viewItem.attributes, { name: 'numExportComparisons' });
                Object.assign(viewItem, { task: 'VECTOR_SET_SEARCH' });
                Object.assign(viewItem, { isBulkStep: true });
                return new GenericTreeNode({
                    name: viewItem.name,
                    automationId: 'bulk-step-' + viewItem.handle,
                    entityType: EntityType.searchResult,
                    iconStringContent: 'B',
                    iconColor: 'tan-07',
                    customNumber: viewItem.documentCount,
                    contextMenuOptions: !SearchSearchHistoryMenu.isLoading ? contextMenuOptionsSearchHistory : null,
                    onContextMenuAction: SearchMenu.onContextMenuAction,
                    isExpandable: hasExportComparisonReports && (hasExportComparisonReports.value > 0),
                    isExpandedOnSelect: true,
                    hasExpanderPadding: false,
                    childPadding: hasExportComparisonReports && (hasExportComparisonReports.value > 0) ? 15 : 25,
                    navigationInfo: (item.viewType === ViewType.CORPUS_SET_RESULT || item.viewType === ViewType.CORPUS_RESULT) ?
                        new NavigationInfo(
                            { name: 'All Docs', path: 'document-list', default: true },
                            { name: 'Communication Grid', path: 'communication-matrix' },
                            { name: 'Domain Grid', path: 'domain-matrix' },
                            { name: 'Reports', path: 'reports' },
                        ) : SearchMenu.navigationInfo,
                    data: viewItem,
                    requestInfo: new DrRequestInfo({
                        endpoint: Endpoint.taskManager_getTasks,
                        responseName: 'tasks[0].compareExportList',
                        data: {
                            taskHandles: [viewItem.handle],
                            includeDrDebug: true,
                            includeResourceStatistics: true
                        }
                    }),
                    createChild: (compareExport: any): GenericTreeNode => {
                        const viewItemChild = new SearchResult(compareExport);
                        viewItemChild.viewType = ViewType.WORKING_SET_RESULT;
                        Object.assign(viewItemChild, { exportComparison: true });
                        return new GenericTreeNode({
                            name: viewItemChild.name,
                            automationId: 'bulk-compare-exports-' + viewItemChild.handle,
                            entityType: EntityType.searchResult,
                            icon: 'fa-search',
                            iconColor: 'color-tan-07',
                            customNumber: viewItemChild.documentCount,
                            navigationInfo: SearchMenu.navigationInfo,
                            data: viewItemChild,
                            parent: childNode,
                            childPadding: 25,
                            contextMenuOptions: contextMenuOptionsSearchHistory,
                            onContextMenuAction: SearchMenu.onContextMenuAction,
                        }, handler);
                    }
                }, handler);
            };
        }

        if ((item.compareExports && item.compareExports.length > 0) || (item.compareExportList && item.compareExportList.length > 0)) {
            childNode.isExpandable = true;
            childNode.isExpandedOnSelect = true;
            childNode.hasExpanderPadding = false;
            childNode.childPadding = 10;
            childNode.parent = SearchSearchHistoryMenu;
            childNode.preloadedData = childNode.data?.compareExports ? childNode.data.compareExports : childNode.data?.compareExportList;
            childNode.createChild = (compareExport: any): GenericTreeNode => {
                const viewItem = new SearchResult(compareExport);
                viewItem.viewType = ViewType.WORKING_SET_RESULT;
                Object.assign(viewItem, { exportComparison: true });
                return new GenericTreeNode({
                    name: viewItem.name,
                    automationId: 'bulk-compare-exports-' + viewItem.handle,
                    entityType: EntityType.searchResult,
                    icon: 'fa-search',
                    iconColor: 'color-tan-07',
                    customNumber: viewItem.documentCount,
                    navigationInfo: SearchMenu.navigationInfo,
                    data: viewItem,
                    childPadding: 25,
                    contextMenuOptions: !SearchSearchHistoryMenu.isLoading ? contextMenuOptionsSearchHistory : null,
                    onContextMenuAction: SearchMenu.onContextMenuAction
                }, handler);
            };
        }
        return childNode;
    }
});

SearchMenu.children = [
    SearchSavedSearchMenu,
    SearchSearchHistoryMenu
];
